<!-- =========================================================================================
    File Name: Email.vue
    Description: Email Application (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<!--  -->
<template>
  <!-- <div id="simple-calendar-app"> -->
  <div>
    <!-- <vx-card :title="!navigationString ? rootModuleName : navigationString" -->
     <!-- :title="rootModuleName" -->
      <!-- v-if="Object.keys(permissions).length > 0" -->
       <!-- :btn-edit="(permissions.can_edit === true && showBtnEdit)" -->
    <vx-card :btn-edit="(permissions.can_edit && showBtnEdit)" :btn-print="showBtnPrint"
      :btn-print-api-token="apiToken" :btn-print-max-timeout="btnPrintTimeout" :btn-print-url="apiDelegator"
      :btn-print-label="btnPrintLabel" :btn-print-data="rowData"
      :module-action-buttons="moduleActionButtons" :trigger-button-function="triggerButtonAction">
      <!-- :canEdit="permissions.can_edit" -->

      <div slot="no-body" class="tabs-container px-6 pt-6" v-show="!showEmptyDataMessage">

        <vs-tabs :key="$route.params.moduleHash" v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab :label="$t('MODULES.details')">
            <vs-alert icon="warning" active="true" color="warning" class="my-5" v-show="showNoFieldsMessage">
              <span>Este módulo não possui campos.</span>
            </vs-alert>
            <div class="tab-text">
              <!-- TODO Migrar blockDataProp para dentro do componente-->
              <module-form class="mt-4" :delegatorUrl="detail.api_delegator" :detailProp="detail" :blockDataProp="blockData" :permissionsProp="permissions"
                :enableEditProp="enableEdit" action-type="view" :blockTabs="blockTabs" />
            </div>

          </vs-tab>

          <vs-tab v-for="relatedTab in defaultTabs" :label="$displayLabel(relatedTab, 'tabName')" :key="relatedTab.tabIndex">
            <related-module-table :relatedTab="relatedTab" :rowState="fieldModel" />
          </vs-tab>
        </vs-tabs>
      </div>
      <vs-alert icon="warning" active="true" color="warning" class="my-5" v-show="showEmptyDataMessage">
        <span>Acesso negado ao módulo.</span>
      </vs-alert>
    </vx-card>
  </div>
</template>

<script>

import ModuleForm from '../../../components/custom-modules/CustomModuleForm.vue'
import RelatedModuleTable from '../../../components/custom-modules/RelatedModuleTable.vue'
import { Edit2Icon, CheckIcon, XIcon, CheckCircleIcon, FacebookIcon, YoutubeIcon, Link2Icon, TwitterIcon, LinkedinIcon, InstagramIcon, PhoneIcon, CalendarIcon, MailIcon, FileIcon, ClockIcon, SlackIcon, PercentIcon, DollarSignIcon } from 'vue-feather-icons'
import VxTimeline from '@/components/timeline/VxTimeline'
import StringMask from 'string-mask'
import { setApplicationLocalStorageItem, performFetch, objectChanges, checkIfStringIsDate, checkIfStringIsDateTime } from '../../../helpers'
import { mapGetters } from 'vuex';

export default {
  components: {
    ModuleForm,
    VxTimeline,
    Edit2Icon,
    CheckIcon,
    XIcon,
    PhoneIcon,
    Link2Icon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    YoutubeIcon,
    FacebookIcon,
    CalendarIcon,
    MailIcon,
    FileIcon,
    ClockIcon,
    SlackIcon,
    PercentIcon,
    DollarSignIcon,
    RelatedModuleTable
  },
  data() {
    return {
      blockTableModel: {},
      formattedRowData: {},
      moduleActionButtons: [],
      rootModuleName: '',
      pagination: {
        currentPage: 1,
        pages: 1,
        per_page: 10,
        total_records: 0
      },
      rowData: {},
      fieldType: {},
      paginationModel: 1,
      showBtnEdit: true,
      orderData: {
        field: null,
        type: null
      },
      paginationIndex: 1,
      totalPages: 100,
      relatedTabs: [],
      defaultTabs: [],
      blockTabs: {},
      selectedRows: [],
      fieldTitle: {},
      fieldName: {},
      tableTitles: [],
      showEmptyDataMessage: false,
      fieldData: {},
      fieldModel: {},
      tabsKey: 0,
      enableEdit: {},
      optionFieldModel: [],
      detail: {},
      showBtnPrint: true,
      btnPrintTimeout: 10,
      btnPrintLabel: 'Imprimir',
      blockData: [],
      fieldHashObject: {},
      permissions: {
        can_edit: false
      },
      relatedModulePermissions: {
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canView: true,
        canList: true,
        canExport: true
      },
      relatedModuleHasDocumentField: true,
      activeTab: 0,
      blockTabsModel: {},
      test: [
        {
          label: "test1"
        },
        {
          label: "test2"
        },
        {
          label: "test3"
        }
      ],
      timeLineData: [],
      showNoFieldsMessage: false,
      moduleRows: [],
      perPage: null,
      apiDelegator: '',
      apiToken: '',
      rowHashToDelete: '',
      moduleHashToDelete: '',
    }
  },
  watch: {
    async '$route.params.moduleHash'(newValue) {
      // this.$vs.loading({ type: "default" })
      // await this.getData()
      // this.$vs.loading.close()
      this.defaultTabs = JSON.parse(JSON.stringify([]));
      this.activeTab = 0;
      this.$vs.loading({ type: 'default' });
      await this.getModuleActions();
      await this.getData();
      this.$vs.loading.close();
    },
    async activeTab(newValue, oldValue) {
      if (this.activeTab === 0) {
        this.blockData = JSON.parse(JSON.stringify(this.blockData))
        this.showBtnEdit = true
        this.$vs.loading({ type: 'default' })
        await this.getData(false)
        this.$vs.loading.close()
      }
    },
  },
  computed: {
    ...mapGetters({
      navigationString: 'relatedModuleNavigation/navigationString'
    })
  },
  async created() {

  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('auth/SET_CURRENT_MODULE_NAME', null)
    next()
  },
  async mounted() {
    this.$vs.loading({ type: 'default' });
    await this.getModuleActions();
    await this.getData();
    this.$vs.loading.close()
  },
  methods: {
    async triggerButtonAction(buttonData) {

      this.$vs.loading({ type: 'default' })
      const user = this.$store.state.auth.user
      const userObject = typeof user === 'string' ? JSON.parse(user) : user
      const userHash = userObject && (userObject.hash || userObject.user_hash)

      await performFetch(`${this.$store.state.auth.api_url}/trigger-button-action`, {
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          user_hash: userHash,
          button_data: buttonData,
          trigger_data: {
            module_hash: this.$route.params.moduleHash,
            row_hash: this.$route.params.rowHash,
            data: this.formattedRowData,
            type: 'row'
          }
        }
      })
        .then(async (response) => {

          if (!response.ok) {
            this.$vs.notify({
              title: 'Erro',
              text: 'Erro ao executar a função',
              iconPack: 'feather',
              icon: 'icon-bell',
              color: 'danger'
            })

            this.$vs.loading.close()

            return
          }

          if (buttonData.wait_response) {
            if (buttonData.response_type === 'notification') {

              const res = await response.json()

              if (res.hasOwnProperty('color') && res.hasOwnProperty('title') && res.hasOwnProperty('message')) {
                this.$vs.notify({
                  title: res.title,
                  text: res.message,
                  iconPack: 'feather',
                  icon: 'icon-bell',
                  color: res.color
                })
              }
            } else {

              const blob = await response.blob();

              const contentDisposition = response.headers.get('Content-Disposition');
              let filename = 'download';  // Nome padrão, caso o cabeçalho não esteja presente
              if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch.length > 1) {
                  filename = filenameMatch[1];
                }
              }

              const mimeType = response.headers.get('Content-Type');

              // Cria um link temporário para forçar o download
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;

              // Define o nome do arquivo para download (opcional)
              a.download = filename;

              // Adiciona o link ao DOM e simula o clique para iniciar o download
              document.body.appendChild(a);
              a.click();

              // Remove o link temporário após o download
              document.body.removeChild(a);

              // Revoga o objeto URL criado para liberar memória
              window.URL.revokeObjectURL(url);

            }
          }

          this.$vs.loading.close()

        })
        .catch((e) => {

          throw new Error(e.message)
        })
    },
    async getModuleActions() {
      this.$vs.loading({ type: 'default' });
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_action__list',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_hash: this.$route.params.moduleHash
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              const roleHash = this.$store.state.auth.role && (this.$store.state.auth.role.identification || this.$store.state.auth.role.hash)
              this.moduleActionButtons = response.actions.filter(x => {
                if (x.button_type !== 'row') return false
                if (!x.roles || x.roles.length === 0) return true
                return roleHash ? x.roles.includes(roleHash) : true
              });

              this.$vs.loading.close();

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            //this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async openDocument(moduleHash, rowHash) {
      this.$vs.loading({ type: 'default' })

      try {
        await performFetch(this.$store.state.auth.api_url, {
          command: 'get_module_row',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            module_token: moduleHash,
            session_token: this.$store.state.auth.token,
            row_hash: rowHash
          }
        })
          .then(async (response) => {
            this.$vs.loading.close()
            if (response.status === 200) {
              response.json().then(async (responseData) => {

                let block = responseData['payload'].find(x => x.index === 1)

                if (block !== undefined && typeof block === "object" && block !== null) {
                  let findDocument = block['fields'].find(x => x.type_id === 28)

                  if (findDocument !== undefined && typeof findDocument === "object" && findDocument !== null) {
                    if ('payload' in findDocument && findDocument.payload !== null) {
                      try {
                        window.open(findDocument['payload'], '_blank')
                      } catch (e) {
                        this.$vs.notify({
                          title: 'Atenção',
                          text: 'Ocorreu um erro ao visualizar o documento. Entre no registro para visualizar.',
                          iconPack: 'feather',
                          icon: 'icon-alert-circle',
                          color: 'danger'
                        })
                        this.$vs.loading.close()
                      }
                    } else {
                      this.$vs.notify({
                        title: 'Atenção',
                        text: 'Nenhum arquivo encontrado para este registro!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                      })
                    }
                  }
                } else {
                  //
                }

                this.$vs.loading.close()
              })
            } else if (response.status == 401) {
              setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
              this.$store.dispatch('auth/signOut')
            } else {
              this.$vs.loading.close()
              this.showEmptyDataMessage = !this.showEmptyDataMessage
            }
          })
          .catch((e) => {
            this.$vs.loading.close()
            this.showEmptyDataMessage = !this.showEmptyDataMessage
            throw new Error(e.message)
          })
      } catch (e) {
        this.$vs.notify({
          title: 'Atenção!',
          text: 'Ocorreu um erro ao visualizar o documento. Entre no registro para visualizar.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }

      this.$vs.loading.close()

    },
    confirmDeleteRecord(moduleHash, rowHash) {
      this.moduleHashToDelete = moduleHash
      this.rowHashToDelete = rowHash
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar Exclusão',
        text: 'Você tem certeza que deseja excluir esse registro ?',
        accept: this.deleteRecord,
        acceptText: 'Excluir'
      })
    },
    async deleteRecord() {

      this.$vs.loading({ type: 'default' })

      const requestBody = {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token,
        module_token: this.moduleHashToDelete,
        row_hash: this.rowHashToDelete
      }

      await performFetch(this.$store.state.auth.api_url, {
        command: 'delete_module_row',
        parameters: requestBody
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              this.$vs.loading.close()

              this.$vs.notify({
                title: 'Operação Realizada!',
                text: response.message,
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
              })

              this.$vs.loading({ type: 'default' })

              this.pagination['currentPage'] = 1
              this.pagination['pages'] = 1
              this.pagesToShow = 1
              this.paginationModel = 1
              const moduleData = this.defaultTabs[this.activeTab - 1]
              await this.listModuleRows(moduleData)
              this.$vs.loading.close()
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else if (response.status == 403) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Atenção!',
              text: 'Você não tem permissão para deletar registros neste módulo!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao deletar o registro',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.moduleHashToDelete = ''
      this.rowHashToDelete = ''
    },
    async getModuleParameters(moduleHash) {
      return new Promise(async (resolve, reject) => {
        await performFetch(this.$store.state.auth.api_url, {
          command: 'list_module_rows_parameters',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: moduleHash
          }
        })
          .then((response) => {
            if (response.status === 200) {
              response.json().then((responseData) => {

                // document.title = `${document.title.split(' | ')[0]} | ${responseData.detail.module_name}`

                // this.$store.dispatch('auth/setBreadcrumb', {title: responseData.detail.module_name})
                // this.$store.commit('SET_CURRENT_MODULE_NAME', responseData.detail.module_name)

                // this.rootModuleName = responseData.detail.module_name

                this.perPage = responseData.detail.lines_per_page

                this.$vs.loading.close()

                resolve(true)
              })
                .catch(e => {
                  this.$vs.loading.close()
                  this.$vs.notify({
                    title: 'Atenção!',
                    text: e.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                  throw new Error(e.message)
                })
            } else if (response.status === 400) {
              this.$router.push(`/modules/view/${this.$route.params.moduleHash}`)
              reject(false)
            } else if (response.status === 403) {
              this.$vs.loading.close()
              this.showEmptyDataMessage = true
              reject(false)
            } else if (response.status === 401) {
              setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
              this.$store.dispatch('auth/signOut')
              reject(false)
            } else {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Operação não realizada!',
                text: 'Ocorreu um erro ao listar os registros do módulo',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              reject(false)
            }
          })
          .catch((e) => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Atenção!',
              text: e.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            reject(e.message)
          })
      })
    },

    async getModuleFieldUpdates() {

      this.$vs.loading({ type: 'default' })

      const iconsDict = {
        1: 'Edit2Icon',
        2: 'Edit2Icon',
        3: 'PhoneIcon',
        4: 'MailIcon',
        5: 'InstagramIcon',
        6: 'FacebookIcon',
        7: 'LinkedinIcon',
        8: 'Link2Icon',
        9: 'TwitterIcon',
        10: 'PhoneIcon',
        11: 'YoutubeIcon',
        12: 'CalendarIcon',
        13: 'ClockIcon',
        14: 'PhoneIcon',
        15: 'SlackIcon',
        16: 'PercentIcon',
        17: 'ClockIcon',
        18: 'DollarSignIcon',
        19: 'Edit2Icon',
        20: 'Edit2Icon',
        21: 'Edit2Icon',
        22: 'FileIcon',
        23: 'FileIcon',
        24: 'ListIcon',
        25: 'ListIcon',
        26: 'ListIcon'
      }

      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_module_field_updates',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          page: this.paginationIndex,
          per_page: 5
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {
              const timeLineData = []

              const colors = ['primary', 'success', 'warning', 'danger']

              let colorIndex = 0

              this.totalPages = response.payload.pagination.pages

              response.payload.updates.forEach((value, key) => {

                let from = value.old_value

                let to = value.new_value

                if (value.field_type_id === 16 || value.field_type_id === 18 || value.field_type_id === 20) {

                  let config = null

                  if (value.field_type_id === 16 || value.field_type_id === 20) {
                    config = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  } else {
                    config = { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  }

                  const parseValue = parseFloat(from)
                  const parseValueTo = parseFloat(to)

                  if (!isNaN(parseValue)) {
                    from = parseFloat(from).toLocaleString('pt-BR', config)

                    if (value.field_type_id === 16) {
                      from = from + '%'
                    }
                  } else {
                    from = null
                  }

                  if (!isNaN(parseValueTo)) {
                    to = parseFloat(to).toLocaleString('pt-BR', config)

                    if (value.field_type_id === 16) {
                      to = to + '%'
                    }
                  } else {
                    to = null
                  }

                }
                // else if (objectValue.mask) {
                //   const formatter = new StringMask(objectValue.mask)
                //   const result = formatter.apply(objectValue.payload)

                //   objectValue = result
                // }
                else {
                  from = from
                  to = to
                }

                const isDateTime = checkIfStringIsDateTime(from)
                const isDateTimeTo = checkIfStringIsDateTime(to)

                if (isDateTime) {

                  const date = from.split(' ')[0].trim()
                  const time = from.split(' ')[1].trim()

                  from = `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]} ${time}`

                }

                if (isDateTimeTo) {

                  const dateTo = to.split(' ')[0].trim()
                  const timeTo = to.split(' ')[1].trim()

                  to = `${dateTo.split('-')[2]}/${dateTo.split('-')[1]}/${dateTo.split('-')[0]} ${timeTo}`

                }


                const isDate = checkIfStringIsDate(from)
                const isDateTo = checkIfStringIsDate(to)

                if (isDate) {

                  from = `${from.split('-')[2]}/${from.split('-')[1]}/${from.split('-')[0]}`
                }

                if (isDateTo) {

                  to = `${to.split('-')[2]}/${to.split('-')[1]}/${to.split('-')[0]}`
                }

                if (to === null) {
                  to = 'Vazio'
                }

                if (from === null) {
                  from = 'Vazio'
                }

                const object = {
                  index: key,
                  color: colors[colorIndex],
                  icon: iconsDict[value.field_type_id],
                  title: `Campo: ${value.field_title}`,
                  desc_one: `De: ${from}`,
                  desc_two: `Para: ${to}`,
                  time: `${value.updated_at.split(' ')[0].split('-')[2]}/${value.updated_at.split(' ')[0].split('-')[1]}/${value.updated_at.split(' ')[0].split('-')[0]} ${value.updated_at.split(' ')[1]}`,
                  user: value.user_name
                }

                timeLineData.push(object)

                if (colorIndex >= 3) {
                  colorIndex = 0
                } else {
                  colorIndex++
                }
              })

              this.timeLineData = timeLineData

              this.$vs.loading.close()
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()

            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao carregar as atualizações do módulo',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

    },
    goRelatedModule(moduleHash, recordHash) {
      window.location.href = `/modules/view/${moduleHash}/${recordHash}`
      // this.$router.push(`/modules/view/${moduleHash}/${recordHash}`)
      // this.$router.go()
    },

    async handleSearch(searchKey) {
      const moduleData = this.defaultTabs[this.activeTab - 1]
      await this.getModuleParameters(moduleData.moduleHash)
      await this.listModuleRows(moduleData, searchKey, this.pagination['currentPage'])
    },
    async reloadTableData(searchKey = null) {

    },
    async buildRowData() {

      const newFieldData = {}

      return new Promise((resolve, reject) => {

        for (let item of Object.keys(this.fieldModel)) {

          if (this.fieldType[item] !== 27) {
            if (this.fieldModel[item] === '') {
              newFieldData[item] = null
            } else if (typeof this.fieldModel[item] === 'object' && this.fieldModel[item] !== null && this.fieldName[item] === 'assigned_to_id') {
              newFieldData[item] = this.fieldModel[item]['value']
            } else if (typeof this.fieldModel[item] === 'object' && this.fieldModel[item] !== null && this.fieldType[item] === 24) {
              if (this.fieldModel[item]['value'] === 0) {
                newFieldData[item] = null
              } else {
                newFieldData[item] = this.fieldModel[item]['value']
              }
            } else if (typeof this.fieldModel[item] === 'object' && this.fieldModel[item] !== null && this.fieldType[item] === 29) {
              newFieldData[item] = this.fieldModel[item]['value']
            } else if (typeof this.fieldModel[item] === 'object' && this.fieldModel[item] !== null && (this.fieldType[item] === 25 || this.fieldType[item] === 30)) {
              if (this.fieldModel[item]['value'] === 0) {
                newFieldData[item] = null
              } else {
                newFieldData[item] = this.fieldModel[item]['value']
              }
            } else if (typeof this.fieldModel[item] === 'string' && this.fieldModel[item] !== null && this.fieldType[item] === 17) {
              if (this.fieldModel[item].length === 6) {
                newFieldData[item] = this.fieldModel[item].slice(0, 2) + ':' + this.fieldModel[item].slice(2, 4) + ':' + this.fieldModel[item].slice(4, 6)
              } else if (this.fieldModel[item].length === 4) {
                newFieldData[item] = this.fieldModel[item].slice(0, 2) + ':' + this.fieldModel[item].slice(2, 4)
              }
            } else if (this.fieldType[item] === 2) {
              try {
                newFieldData[item] = parseInt(this.fieldModel[item])
              } catch (e) {

              }
            } else if (this.fieldType[item] === 16 || this.fieldType[item] === 18 || this.fieldType[item] === 20 || this.fieldType[item] === 20) {
              try {
                newFieldData[item] = parseFloat(this.fieldModel[item])
              } catch (e) {

              }
            } else {

              const isDateTime = checkIfStringIsDateTime(this.fieldModel[item])

              if (isDateTime) {
                const dateStr = this.fieldModel[item].split(' ')[0].trim()
                const hourStr = this.fieldModel[item].split(' ')[1].trim()
                newFieldData[item] = `${dateStr.split('/')[2]}-${dateStr.split('/')[1]}-${dateStr.split('/')[0]} ${hourStr}`
              } else {

                const isDate = checkIfStringIsDate(this.fieldModel[item])

                if (isDate) {
                  newFieldData[item] = `${this.fieldModel[item].split('/')[2]}-${this.fieldModel[item].split('/')[1]}-${this.fieldModel[item].split('/')[0]}`
                } else {
                  newFieldData[item] = this.fieldModel[item]
                }
              }
            }
          }
        }

        resolve(newFieldData)

      })
    },
    setFieldsModels(fieldItem) {

      if (fieldItem.payload === '') {
        fieldItem.payload = null
      }

      //START FORMAT FIELD PAYLOAD BY TYPE ID

      // if (fieldItem.type_id === 12) {

      //   if (fieldItem.payload !== null && fieldItem.payload !== '') {
      //     let formattedPayload = fieldItem.payload

      //     formattedPayload = `${formattedPayload.split('-')[2]}/${formattedPayload.split('-')[1]}/${formattedPayload.split('-')[0]}`

      //     fieldItem.payload = formattedPayload

      //     this.$set(this.fieldModel, fieldItem.hash, formattedPayload)
      //   } else {
      //     this.$set(this.fieldModel, fieldItem.hash, '')
      //   }

      // } else if (fieldItem.type_id === 13) {

      //   if (fieldItem.payload !== null && fieldItem.payload !== '') {
      //     let formattedPayload = fieldItem.payload

      //     const date = formattedPayload.split(' ')[0].trim()

      //     const hour = formattedPayload.split(' ')[1].trim()

      //     formattedPayload = `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]} ${hour}`

      //     fieldItem.payload = formattedPayload

      //     this.$set(this.fieldModel, fieldItem.hash, formattedPayload)
      //   } else {
      //     this.$set(this.fieldModel, fieldItem.hash, '')
      //   }

      // }

      if (fieldItem.type_id === 20) {

        if (fieldItem.payload === '' || fieldItem.payload === null) {
          fieldItem.payload = 0
        } else {
          fieldItem.payload = parseFloat(fieldItem.payload)
        }
      } else if (fieldItem.type_id === 16) {

        if (fieldItem.payload === '' || fieldItem.payload === null) {
          fieldItem.payload = 0
        } else {
          fieldItem.payload = parseFloat(fieldItem.payload)
        }
      } else if (fieldItem.type_id === 18) {

        if (fieldItem.payload === '' || fieldItem.payload === null) {
          fieldItem.payload = 0
        } else {
          fieldItem.payload = parseFloat(fieldItem.payload)
        }
      } else if (fieldItem.type_id === 24) {

        this.$set(this.fieldModel, fieldItem.hash, {})
        const optionsList = []
        fieldItem.options.forEach((optionFieldItem) => {

          optionsList.push({ hash: optionFieldItem.value, name: optionFieldItem.label })

          if (optionFieldItem.selected) {
            this.fieldModel[fieldItem.hash] = { hash: optionFieldItem.value, name: optionFieldItem.label }
          }
        })

        this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
      } else if (fieldItem.type_id === 29) {
        this.$set(this.fieldModel, fieldItem.hash, {})
        const optionsList = []
        fieldItem.options.forEach((optionFieldItem) => {
          optionsList.push({ hash: optionFieldItem.value, label: optionFieldItem.label, color: optionFieldItem.color })
        })

        const defaultValue = optionsList.find(x => x.label === fieldItem.default_value)

        this.$set(this.fieldModel, fieldItem.hash, defaultValue)

        // this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
      } else if (fieldItem.type_id === 25 || fieldItem.type_id === 30) {
        this.$set(this.fieldModel, fieldItem.hash, {})
        const optionsList = []
        if (Array.isArray(fieldItem.options)) {
          fieldItem.options.forEach((optionFieldItem) => {

            optionsList.push({ hash: optionFieldItem.value, name: optionFieldItem.label })

            if (optionFieldItem.selected) {
              this.fieldModel[fieldItem.hash] = { hash: optionFieldItem.value, name: optionFieldItem.label }
            }
          })
        } else {
          // this.$set(this.dependentFieldOptions, fieldItem.hash, fieldItem.options)

          if (JSON.stringify(this.fieldModel[fieldItem['related_parent_hash']]) === '{}') {
            // this.$set(this.optionFieldModel, fieldItem.hash, [])
            // this.$set(this.dependentFieldDisableStatus, fieldItem.hash, true)
          } else {

            Object.keys(fieldItem.options).forEach(item => {
              fieldItem.options[item].forEach((itemOption) => {
                if (item === this.fieldModel[fieldItem['related_parent_hash']].hash) {
                  if (itemOption.selected) {
                    this.fieldModel[fieldItem.hash] = { hash: itemOption.value, name: itemOption.label }
                  }
                }
              })
            })

            // this.relatedModuleFieldChange(fieldItem['related_parent_hash'], this.fieldModel[fieldItem['related_parent_hash']], defaultOption)
          }
        }

        this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
      } else if (fieldItem.type_id === 21) {
        this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
      } else if (fieldItem.type_id === 22) {
        this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
      } else if (fieldItem.type_id === 27) {

        this.fillMapFields()
        if (typeof fieldItem.payload === 'string' && fieldItem.payload.split(',').length > 0) {
          fieldItem.payload = { lat: parseFloat(fieldItem.payload.split(',')[0]), lng: parseFloat(fieldItem.payload.split(',')[1]) }
        } else {
          fieldItem.payload = { lat: -23.501103, lng: -46.8504457 }
        }

      } else if (fieldItem.type_id === 28) {
        this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
      }

      if (fieldItem.type_id !== 24 && fieldItem.type_id !== 25 && fieldItem.type_id !== 29 && fieldItem.type_id !== 30) {
        this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
      }

      this.$set(this.fieldTitle, fieldItem.hash, fieldItem.title)
      this.$set(this.fieldName, fieldItem.hash, fieldItem.name)
      this.$set(this.fieldType, fieldItem.hash, fieldItem.type_id)

    },
    buildBlocks() {

      return new Promise((resolve, reject) => {
        for (let block of this.blockData) {
          for (let fieldItem of block.fields) {
            this.setFieldsModels(fieldItem)
          }
        }

        resolve(true)
      })
    },
    async getData(loadTabs = true) {

      const requestBody = {
        application_token: this.$store.state.auth.app_token,
        module_token: this.$route.params.moduleHash,
        session_token: this.$store.state.auth.token
      }

      if (this.$route.params.rowHash) {
        requestBody['row_hash'] = this.$route.params.rowHash
      }

      return await performFetch(this.$store.state.auth.api_url, {
        command: 'get_module_row',
        parameters: requestBody
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (responseData) => {

              for (const row of responseData.data) {
                this.$set(this.formattedRowData, row['hash'], row['payload']);
              }

              this.rootModuleName = responseData.detail.module_name

              if (responseData.related_tabs.length > 0) {

                let tabIndex = 1

                responseData.related_tabs.forEach((item) => {

                  let icon = item.icon.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`)

                  icon = icon.replace('-icon', '')

                  icon = 'icon' + icon

                  const found = this.defaultTabs.find(element => element.moduleHash === item.module_hash)

                  if (found === undefined || !found) {
                    this.defaultTabs.push({
                      tabIndex: tabIndex,
                      index: item.index,
                      name: item.module_name,
                      icon: icon,
                      tabName: item.tab_name === null ? item.module_name : item.tab_name,
                      tabName_en: item.tab_name_en || null,
                      recordHash: item.record_hash,
                      moduleHash: item.module_hash,
                      fieldHash: item.field_hash
                    })
                  }

                  tabIndex++
                })
              }

              if (loadTabs && Object.keys(responseData.custom_module_tabs).length > 0) {

                Object.entries(responseData.custom_module_tabs).forEach((objectData, index) => {
                  const [blockHash, blockTabs] = objectData

                  if (!this.blockTabs.hasOwnProperty(blockHash)) {
                    this.blockTabs[blockHash] = []
                  }

                  blockTabs.forEach((value, key) => {
                    let icon = 'icon' + value.icon.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`).replace('-icon', '')

                    this.blockTabs[blockHash].push({
                      tabIndex: key,
                      index: value.index,
                      name: value.module_name,
                      icon: icon,
                      tabName: value.tab_name === null ? value.module_name : value.tab_name,
                      tabName_en: value.tab_name_en || null,
                      recordHash: value.record_hash,
                      moduleHash: value.module_hash,
                      fieldHash: value.field_hash
                    })
                  })
                })

              }

              this.detail = responseData.detail
              this.apiDelegator = responseData.detail.api_delegator
              this.apiToken = responseData.api_token
              this.detail.module_hash = this.$route.params.moduleHash
              this.showBtnPrint = responseData.detail.show_print_button
              this.btnPrintTimeout = responseData.detail.max_print_timeout
              this.btnPrintLabel = responseData.detail.print_button_label
              document.title = `${document.title.split(' | ')[0]} | ${this.$displayLabel(responseData.detail, 'module_name')}`
              this.$store.commit('auth/SET_CURRENT_MODULE_NAME', { module_name: responseData.detail.module_name, module_name_en: responseData.detail.module_name_en })
              if (responseData.payload.length > 0) {
                this.blockData = responseData.payload
                await this.buildBlocks()
                if (responseData.hasOwnProperty('data')) {
                  this.rowData = responseData.data.reduce((obj, item) => (obj[item.hash] = item.payload, obj), {})
                }
                const visibleBlocks = responseData.payload.filter((el) => el.visible)
                if (visibleBlocks.length === 0) {
                  this.showNoFieldsMessage = true
                }
                this.$set(this.permissions, 'can_edit', responseData.permissions.can_edit)
              } else {
                this.showEmptyDataMessage = !this.showEmptyDataMessage
              }

              if (responseData.detail.identifier_field !== null) {
                let moduleFieldValue = null

                for (const block of responseData.payload) {
                  for (const field of block.fields) {
                    if (field.hash === responseData.detail.identifier_field) {
                      moduleFieldValue = field.payload
                    }
                  }
                }
              }
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.showEmptyDataMessage = !this.showEmptyDataMessage
          }
        })
        .catch((e) => {
          // this.$vs.notify({
          //   title: 'Operação não realizada!',
          //   text: e.message,
          //   iconPack: 'feather',
          //   icon: 'icon-alert-circle',
          //   color: 'danger'
          // })
          this.showEmptyDataMessage = !this.showEmptyDataMessage
          throw new Error(e.message)
        })
    }
  }
}

</script>


<style lang="scss">
.text-muted {
  font-size: 11px;
  color: #839bb3 !important;
  padding-left: 5px;
}

.vs-input--label {
  font-size: 14px;
}
</style>
